import { render, staticRenderFns } from "./BoardDetails.vue?vue&type=template&id=b9db195a&scoped=true&"
import script from "./BoardDetails.vue?vue&type=script&lang=js&"
export * from "./BoardDetails.vue?vue&type=script&lang=js&"
import style0 from "./BoardDetails.vue?vue&type=style&index=0&id=b9db195a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db195a",
  null
  
)

export default component.exports